// extracted by mini-css-extract-plugin
export default {"textCard":"TextSourceCard_textCard__5-bvz"};